import { Box, Button, Flex, Image, Text } from '@chakra-ui/react'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const MobileSuccess: React.FC = () => {
  const [t] = useTranslation()

  return (
    <Flex
      flexDirection={['column', 'column', 'column', 'row', 'row']}
      bg='white'
      justifyContent='center'
      alignItems='center'
      marginBottom='50px'
    >
      <Helmet>
        <title>{t('onboard.success.title')} | Education Journey</title>
      </Helmet>
      <Box display={['none', 'none', 'flex', 'flex', 'flex']}>
        <Image src='/assets/images/success-baloon-girl.svg' />
      </Box>
      <Flex
        flexDirection='column'
        justifyContent='center'
        alignItems='center'
        width={['90%', '90%', '600px', '600px', '600px']}
      >
        <Text
          fontWeight='regular'
          fontFamily='Poppins'
          fontSize={['28px', '28px', '36px', '36px', '36px']}
          color='gray.800'
        >
          {t('onboard.success.mobile.Welcome to')}
        </Text>
        <Text
          fontWeight='extrabold'
          color='primaryColors.400'
          fontFamily='Poppins'
          fontSize={['28px', '28px', '36px', '48px', '48px']}
          marginBottom='10px'
          textAlign='center'
        >
          Education Journey
        </Text>
        <Box display={['flex', 'flex', 'none', 'none', 'none']}>
          <Image src='/assets/images/success-baloon-girl.svg' />
        </Box>
        <Text fontFamily='Mulish'>{t('onboard.success.mobile.Click the link below and access your courses')}</Text>
        <Flex>
          <Button marginTop='40px' variant='yellow' w='100%' paddingX='50px' as={Link} to='/home'>
            {t('onboard.success.mobile.Button')}
          </Button>
        </Flex>
      </Flex>
      <Box display={['none', 'none', 'flex', 'flex', 'flex']}>
        <Image marginTop='80px' src='/assets/images/success-baloons.svg' />
      </Box>
    </Flex>
  )
}

export default MobileSuccess
